(function () {
  function init(wrap) {
    if (wrap.dataset.nxReady) return;
    wrap.dataset.nxReady = '1';
    var track = wrap.querySelector('[data-nx-track]');
    var bar = wrap.querySelector('[data-nx-progress]');
    var prev = wrap.querySelector('[data-nx-prev]');
    var next = wrap.querySelector('[data-nx-next]');
    if (!track) return;
    function step() {
      var card = track.firstElementChild;
      return card ? card.getBoundingClientRect().width + 16 : track.clientWidth * 0.8;
    }
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var scrollable = max > 4;
      wrap.classList.toggle('is-scrollable', scrollable);
      if (bar) {
        var visible = track.clientWidth / track.scrollWidth;
        var pos = max > 0 ? track.scrollLeft / max : 0;
        bar.style.width = Math.max(visible * 100, 12) + '%';
        bar.style.transform = 'translateX(' + (pos * (100 / Math.max(visible, 0.12) - 100)) + '%)';
      }
      if (prev) prev.disabled = track.scrollLeft <= 4;
      if (next) next.disabled = track.scrollLeft >= max - 4;
    }
    if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
    track.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  }
  function boot() { document.querySelectorAll('[data-nx-scroll]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();